import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "avatar",
  "use": "avatar-usage",
  "viewBox": "0 0 164 164",
  "content": "<symbol viewBox=\"0 0 164 164\" id=\"avatar\">\n    <defs>\n        <rect id=\"avatar_a\" width=\"164\" height=\"164\" rx=\"3\" />\n    </defs>\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <mask id=\"avatar_b\" fill=\"#fff\">\n            <use xlink:href=\"#avatar_a\" />\n        </mask>\n        <use fill=\"#3FAFF3\" xlink:href=\"#avatar_a\" />\n        <path fill=\"#B9E5FF\" fill-rule=\"nonzero\" d=\"M137.374 125.702c0-5.67-3.666-10.483-8.756-12.188-.4-.136-26.45-6.79-30.178-14.192-1.7-3.381-.024-7.713 1.674-10.7a51.92 51.92 0 0 0 2.268-3.314c4.413-7.069 7.781-16.358 8.124-27.84.516-17.273-12.85-31.302-28.718-31.343-15.94.04-29.306 14.07-28.787 31.344.343 11.482 3.708 20.77 8.12 27.832a50.029 50.029 0 0 0 2.269 3.32c1.698 2.988 3.374 7.32 1.674 10.702-3.725 7.401-29.778 14.056-30.179 14.192-5.089 1.704-8.76 6.518-8.76 12.188v11.673h111.25v-11.674z\" mask=\"url(#avatar_b)\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatar.svg
// module id = ./src/assets/img/avatar.svg
// module chunks = 4